module.exports = __webpack_public_path__ + "img/691f69e81ce8e7cd2a091aa274e8c923.png";